(function () {
  'use strict';

  const angular = window.angular;

  HomeController.$inject = ['assetUtilsService', 'ColorUtils', '$translate', '$sce', 'AppUtils'];

  angular.module('app').component('projectLinks', {
    template:'<div class="marginLR20"><div><div class="row row-2x"><div class="col-md-3 hidden-sm hidden-ms hidden-xs hidden"><h3 class="text-info marginT0" translate>views.project.summary</h3><hr class="marginT0"><table class="table table-borderless table-condensed"><tr><td style="width: 150px" translate>views.project.assetCount</td><td>: <strong>{{ctrl.cameras.length}}</strong></td></tr><tr><td translate>views.project.connectedAssets</td><td>: <strong>{{ctrl.connected.length}}</strong> <small ng-if="ctrl.cameras.length && ctrl.connected.length">( {{ctrl.connected.length * 100 / ctrl.cameras.length | number:1}}% )</small></td></tr><tr><td translate>views.project.parentCount</td><td>: <strong>{{ctrl.parents.length}}</strong></td></tr><tr><td translate>entities.user.modelNamePl</td><td>: <strong>{{ctrl.managerCount}}</strong></td></tr></table></div><div class="col-md-6 col-md-offset-3"><div class="marginTB10"><div class="form-group"><div class="input-group"><span class="input-group-addon"><i class="fas fa-search fa-fw"></i></span> <input ng-model="ctrl.searchText" ng-change="ctrl.filterLinks()" class="form-control" translate-attr="::{placeholder: \'buttons.search\'}"></div></div></div><div><div class="home-shortcuts"><div ng-if="ctrl.projectAdminLinks.length" class="marginB20"><h3 translate>entities.tool.adminTools.modelNamePl</h3><a class="shortcut" ui-sref="^.^.{{link.path.base? link.path.base + \'.\' + link.path.view: link.path}}" ng-repeat="link in ctrl.projectAdminLinks"><div class="shortcut-content"><div class="link-icon"><i class="{{link.icon}}"></i></div><div class="link-text-wrapper"><div class="link-text"><span ng-bind-html="link.label"></span></div></div></div></a><div class="clearfix"></div></div><div class="marginB20"><h3 ng-if="ctrl.projectLinks.length" translate>views.project.visualizationTools</h3><a class="shortcut" ui-sref="^.^.{{link.path.base? link.path.base + \'.\' + link.path.view: link.path}}" ng-repeat="link in ctrl.projectLinks"><div class="shortcut-content"><div class="link-icon"><i class="{{link.icon}}"></i></div><div class="link-text-wrapper"><div class="link-text"><span ng-bind-html="link.label"></span></div></div></div></a><div class="clearfix"></div></div><div class="marginB20"><h3 ng-if="ctrl.projectConfigLinks.length" translate>views.project.configurationTools</h3><a class="shortcut" ui-sref="^.^.{{link.path.base? link.path.base + \'.\' + link.path.view: link.path}}" ng-repeat="link in ctrl.projectConfigLinks"><div class="shortcut-content"><div class="link-icon"><i class="{{link.icon}}"></i></div><div class="link-text-wrapper"><div class="link-text"><span ng-bind-html="link.label"></span></div></div></div></a><div class="clearfix"></div></div></div></div></div><div class="col-md-3 hidden-sm hidden-ms hidden-xs hidden"><h3 class="text-info marginT0" translate>views.project.plugins</h3><hr class="marginT0"><div class="home-plugins"><svg-plugin-display ng-repeat="plugin in ctrl.project.tags" fill-color="ctrl.pluginsColor" show-label="true" plugin="plugin.icon"></svg-plugin-display></div></div></div></div></div>',
    controller: HomeController,
    controllerAs: 'ctrl',
    bindings: {
      project: '<',
      customer: '<',
      assets: '<',
      tools: '<',
      isAdmin: '<',
      user: '<',
      managerCount: '<',
    },
  });

  function HomeController(AssetUtilsService, ColorUtils, $translate, $sce, utils) {
    let vm = this;

    vm.$onInit = function () {
      vm.searchText = '';
      vm.pluginsColor = ColorUtils.getColor('main');

      vm.filterLinks = filterLinks;

      (vm.project.tags || []).sort((a, b) => {
        const label1 = $translate.instant(`plugins.${a.name}`);
        const label2 = $translate.instant(`plugins.${b.name}`);
        return label1 > label2 ? 1 : -1;
      });

      const assets = vm.assets.tree;
      vm.connected = [];
      vm.cameras = assets.reduce((filtered, current) => {
        const asset = vm.assets.assets[current.id];
        if (asset.type === 'ObjectRecognitionCam') {
          filtered.push(current.id);
          if (current.li_attr['data-status'] === 'online') {
            vm.connected.push(current.id);
          }
        }
        return filtered;
      }, []);
      vm.views = vm.user.views || {};

      vm.hasConfigTools =
        vm.isAdmin ||
        [
          'xompassContextualization',
          'xompassTemplateContextualization',
          'xompassKPIEngine',
          'xompassResponseProtocol',
          'xompassEdgeDevices',
        ].reduce((hasConfigTools, current) => hasConfigTools || !!vm.views[current], false);

      let canAccessAgents = vm.user.isAdmin || vm.user.isMaster;
      if (!canAccessAgents) {
        const views = vm.user.views || {};
        canAccessAgents = views.xompassEdgeDevices != null;

        if (!canAccessAgents) {
          const permissions = vm.user.permission || {};
          const devices = permissions.devices || {};
          const agents = permissions.agents || permissions.edgeAgents || {};
          canAccessAgents = Object.keys(devices)
            .filter((key) => key !== 'read')
            .some((key) => devices[key] === true);

          if (!canAccessAgents) {
            canAccessAgents = Object.keys(agents)
              .filter((key) => key !== 'read')
              .some((key) => agents[key] === true);
          }
        }
      }

      vm.canAccessAgents = canAccessAgents;

      AssetUtilsService.getFilteredAssetTree(Object.values(vm.assets.assets), vm.cameras).then(
        (result) => {
          vm.assetsTree = result.tree;
          vm.assets = result.assets;
          vm.parents = vm.assetsTree.filter((current) => current.parent === '#');
        }
      );

      vm.configLinks = vm.projectLinks = structuredClone(vm.project.links || []);
      vm.projectAdminLinks = structuredClone(vm.project.adminLinks || []);
      vm.projectConfigLinks = getConfigLinks();

      function filterLinks() {
        if (!vm.searchText) {
          vm.projectLinks = structuredClone(vm.project.links || []);
          vm.projectAdminLinks = structuredClone(vm.project.adminLinks || []);
          vm.projectConfigLinks = getConfigLinks();
          return;
        }

        vm.projectLinks = vm.project.links.filter((link) => {
          return link.searchLabel.includes(vm.searchText.toLowerCase());
        });

        vm.projectAdminLinks = (vm.project.adminLinks || []).filter((link) => {
          return link.searchLabel.includes(vm.searchText.toLowerCase());
        });

        vm.projectConfigLinks = vm.projectConfigLinks.filter((link) => {
          return link.searchLabel.includes(vm.searchText.toLowerCase());
        });
      }

      function getConfigLinks() {
        const configLinks = [];
        if (vm.isAdmin || vm.views.xompassContextualization) {
          let label = $translate.instant('entities.tool.static.contextualization');
          configLinks.push({
            label: label,
            searchLabel: utils.removeAccents(label.replace(/<[^>]+>/gm, '').toLowerCase()),
            icon: 'fas fa-cog',
            path: 'contextualization.assets({assetId: null, tab: null})',
          });

          label = $translate.instant('entities.tool.static.templateContextualization');
          configLinks.push({
            label: label,
            searchLabel: utils.removeAccents(label.replace(/<[^>]+>/gm, '').toLowerCase()),
            icon: 'fas fa-copy',
            path: 'assetTemplates({assetTemplateId: null})',
          });
        }

        if (vm.isAdmin || vm.views.xompassEdgeDevices) {
          const label = $translate.instant('entities.edgeagent.modelNamePl');
          configLinks.push({
            label: label,
            searchLabel: utils.removeAccents(label.replace(/<[^>]+>/gm, '').toLowerCase()),
            icon: 'fas fa-wifi',
            path: 'contextualization.agents({deviceId: null, agentId: null})',
          });
        }

        if (vm.isAdmin || vm.views.xompassKPIEngine) {
          const label = $translate.instant('entities.tool.static.kpiEngine');
          configLinks.push({
            label: label,
            searchLabel: utils.removeAccents(label.replace(/<[^>]+>/gm, '').toLowerCase()),
            icon: 'fas fa-calculator',
            path: 'kpiEngine({virtualGroupId: null})',
          });
        }

        if (vm.isAdmin || vm.views.xompassResponseProtocol) {
          const label = $translate.instant('entities.tool.static.responseProtocol');
          configLinks.push({
            label: label,
            searchLabel: utils.removeAccents(label.replace(/<[^>]+>/gm, '').toLowerCase()),
            icon: 'fas fa-tasks',
            path: 'responseProtocols({protocolId: null})',
          });
        }

        return configLinks;
      }
    };
  }
})();
